// ============================================================================
// CACHE HELPERS
// ============================================================================

const CACHE_KEY_PREFIX = 'zt_cache_';
const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes - data considered "fresh"

const getCacheKey = (departmentId) => `${CACHE_KEY_PREFIX}${departmentId}`;

export const loadFromCache = (departmentId) => {
  try {
    const cached = localStorage.getItem(getCacheKey(departmentId));
    if (cached) {
      const { data, timestamp } = JSON.parse(cached);
      return { data, timestamp, isFresh: Date.now() - timestamp < CACHE_TTL_MS };
    }
  } catch (e) {
    console.warn('Cache read error:', e);
  }
  return null;
};

export const saveToCache = (departmentId, data) => {
  try {
    localStorage.setItem(getCacheKey(departmentId), JSON.stringify({
      data,
      timestamp: Date.now()
    }));
  } catch (e) {
    console.warn('Cache write error:', e);
  }
};
